module.exports = __webpack_public_path__ + "img/egold.407b5a2d.png";